import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import balanceSheetTemplate from './balanceSheet.template.html';

export default angular
  .module('books.ui.balanceSheet', [csmCommonWeb, booksService])
  .directive('balanceSheet', balanceSheetDirective).name;

// @ngInclude
function balanceSheetDirective(BooksSvc, BusyScreen) {
  /* acctSin
    /* Label for type of report in singular format
    /*
    /* acctPL 
    /* Label for type of report in plural format
    /* 
    /* hideSort 
    /* Hides the Sort By <div> when true.
    /* 
    /* reportByHide 
    /* Hides the "report by" div when true.
    */
  return {
    template: balanceSheetTemplate,
    scope: {
      acctSin: '@',
      acctPl: '@',
      hideSort: '@',
      reportByHide: '@'
    },
    link: function ($scope, element, attr) {
      var mGroups = [];
      var mAllOption = { id: 0, description: 'All Groups' };

      /*---------------------------------------------------------*/
      /* Sets the defaults of the report to be pulled by account */
      /* and account name and puts the report in PDF format.     */
      /*---------------------------------------------------------*/
      $scope.req = {
        reportByGroup: false,
        order: 'NAME',
        reportFormat: 'PDF'
      };
      $scope.data = {};

      /*****************************************************************************
       * checkGroup */
      /**
       * Verifies the groupID entry. If -1 clears the text on blur.
       *****************************************************************************/
      $scope.checkGroup = function () {
        if ($scope.req.groupID == -1) {
          $scope.data.group = null;
        }
      };

      /*--------------------------------------------------*/
      /* Watches the data.group and sets the groupID to   */
      /* -1 (all groups) if an invalid selection was made */
      /*--------------------------------------------------*/
      $scope.$watch('data.group', function (group) {
        var groupSelected = group && angular.isObject(group);
        $scope.req.groupID = groupSelected ? group.id : -1;
      });

      /*-----------------------------------*/
      /* Adds the mAllOption (No Group) to */
      /* the top of the groups typeahead   */
      /*-----------------------------------*/
      $scope.getGroups = function (text) {
        return [mAllOption].concat(
          mGroups.filter(function (g) {
            return g.description.toLowerCase().indexOf(text.toLowerCase()) > -1;
          })
        );
      };

      /*****************************************************************************
       * formatLabel */
      /**
       * Returns the corresponding groups from the organization to display in the
       * typeahead. .
       * When no match is found will return "No Group".
       *
       * @param  model  Current model value
       * @return        Corresponding group from the organization.
       *****************************************************************************/
      $scope.formatLabel = function (model) {
        if ($scope.groups)
          for (var i = 0; i < $scope.groups.length; i++) {
            if ($scope.groups[i].id == model) {
              return $scope.groups[i].description;
            }
          }
        return 'No Group';
      };

      /*****************************************************************************
       * reportByAccount */
      /**
       * Sets the report to be pulled by the account and checks that the groupID is 0
       *****************************************************************************/
      $scope.reportByAccount = function () {
        $scope.req.reportByGroup = false;
        $scope.req.groupID = 0;
      };

      /*****************************************************************************
       * reportByGroup */
      /**
       * Sets the report to be pulled by the group and allows the selection of which
       * group can be pulled
       *****************************************************************************/
      $scope.reportByGrp = function () {
        $scope.req.reportByGroup = true;
      };

      /*--------------------------------------*/
      /* Works with CSMValidator to make sure */
      /* that the date field is populated.    */
      /*--------------------------------------*/
      $scope.valOption = {};
      $scope.validateInput = function () {
        return $scope.valOption.validate();
      };

      /*--------------*/
      /* Get services */
      /*--------------*/
      BooksSvc.getAccountGroups().then(function (resp) {
        mGroups = resp.data.sort(function (a, b) {
          return a.description
            .toLowerCase()
            .localeCompare(b.description.toLowerCase());
        });

        BooksSvc.getOrganization().then(function (resp) {
          $scope.org = resp.data;
        });
        BusyScreen.setBusy(false);
      });
    }
  };
}
